import Container from 'typedi';
import { LoggerProvider } from '../src/modules/logger';
import { HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    HeartBeat = '/api/SessionData/HeartBeat',
}

export default class SessionApi {
    public static HeartBeat = async (): Promise<boolean> => {
        const logger = Container.get(LoggerProvider).getLogger('SessionApi');
        const { response, errorResponse } = await ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.HeartBeat,
            method: HTTPVerb.POST,
        });

        if (response) {
            logger.debug('HeartBeat was successfully updated!');
            return true;
        } else if (errorResponse) {
            logger.error(
                `HeartBeat request failed with the following error: ${JSON.stringify(
                    errorResponse,
                    Object.getOwnPropertyNames(errorResponse),
                )}`,
            );
            return false;
        }
    };
}
